import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import { getRestEndpoint } from '../../../endpoints';

axios.defaults.baseURL = getRestEndpoint();

const { jwt } = useJwt(axios, {
  // Endpoints
  loginEndpoint: '/api/v1/analyst-users/tokens',
  // refreshEndpoint: '/refresh-token',
  // logoutEndpoint: '/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'userTokenCell',
  storageRefreshTokenKeyName: 'refreshTokenCell',
})
export default jwt
